import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import "./piechartbox.css";

const COLORS = [
  "#4f46e5", // Indigo
  "#22c55e", // Green
  "#ef4444", // Red
  "#f59e0b", // Amber
  "#06b6d4", // Cyan
  "#8b5cf6", // Violet
  "#ec4899", // Pink
  "#10b981", // Emerald
  "#3b82f6", // Blue
  "#eab308", // Yellow
];

// ✅ Custom label renderer (outside chart)
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  percent,
  name,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = outerRadius + 25; // 👉 push labels outside
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#000000"
      fontWeight="bold"
      fontSize={12}
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${name} ${(percent * 100).toFixed(1)}%`}
    </text>
  );
};

const PieChartBox = ({ title, data }) => {
  return (
    <div className="pieChartBox"
    style={{ 

      bordeRadius: "16px",
      height: "28vh",
      border: ".4vw solid #ff92cf", // slightly darker pink border
      boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
      color: "#000000",
      width: "80vw",

    }}>
      <h3 
      className="chart-title"
      >
        {title}
      </h3>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="45vw"
            cy="40vh"
            outerRadius={".50vw"}
            fill="#8884d8"
            dataKey="value"
            label={renderCustomizedLabel} // ✅ custom label
          >
            {data.map((_, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: "#ffb6c1",
              border: "none",
              borderRadius: "8px",
              color: "#000",
              fontWeight: "bold",
            }}
            itemStyle={{ color: "#000", fontWeight: "bold" }}
            formatter={(value) =>
              value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            }
          />
          <Legend
            verticalAlign="bottom"
            height={50}
            wrapperStyle={{
              color: "#fff",
              fontWeight: "bold",
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartBox;
